import React from 'react';
import PropTypes from 'prop-types';
import ErrorPage from './ErrorPage.js';
import ActionComponent from './ActionComponent.js';

const GeneralErrorPage = ({ type }) => {

  return (
    <ErrorPage
      imageSrc={type.imageSrc}
      alt={type.alt}
      title={type.title}
      message={type.message}
      actionComponent={<ActionComponent buttons={type.buttons} />}
    />
  );
};

GeneralErrorPage.propTypes = {
  type: PropTypes.object,
};

export default GeneralErrorPage;
